// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__vLadM","content":"Layout_content__QXmK3"};